<template>
  <div>
    <CRow :class="$hasAuthor('ROLE_ADMIN') ? '' : 'mt-4'">
      <CCol md="12">
        <CCard class="mt-3">
          <CCardHeader color="light" class="d-inline-flex justify-content-between align-items-center">
            <div>
              <i class="fa fa-tachometer"></i>
              <strong> Thống kê thiết bị </strong>
            </div>
            <!--            <small>theo chức vụ</small>-->
            <CButton color="primary" class="text-right" @click="loadDataStatistic()">
              <i class="fa fa-refresh"></i>&nbsp;Tải lại
            </CButton>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <!-- <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="$hasAuthor('ROLE_ADMIN') || $hasAuthor('ROLE_PROVINCE')">
                <BaseSelect :options="districtCodeInput.options" :data="districtCodeInput.data"
                            ref="districtCodeInput"></BaseSelect>
              </CCol>
              <CCol xs="12" sm="6" md="6" lg="6" xl="2" v-if="!$hasAuthor('ROLE_WARD')">
                <BaseSelect :options="wardCodeInput.options" :data="wardCodeInput.data"
                            ref="wardCodeInput"></BaseSelect>
              </CCol> -->
              <CCol xs="12" sm="12" md="12" lg="12" xl="12" class="mt-4">
                <CCard>
                  <CCardHeader color="light">
                    <i class="fa fa-desktop"></i>
                    <strong> Thiết bị <span v-if="statistic && statistic.devices">({{ statistic.devices.total }})</span></strong>
                  </CCardHeader>
                  <CCardBody class="row" v-if="statistic && statistic.devices">
                    <CCol md="3">
                      <CWidgetProgressIcon
                        :header="(statistic.devices.totalConnect && statistic.devices.totalConnect.toString()) || '0'"
                        text="Đang kết nối"
                        :inverse="true"
                        color="gradient-success">
                        <i class="fa fa-rss"></i>
                        <div slot="progress">
                          <CProgress
                            :value="getPercentConnect"
                            :showPercentage="true"
                            :showValue="true"
                            color="secondary"
                            height="13px"
                            :striped="false"
                            :animated="true"
                            class="progress-xs progress-white my-3 mb-0"
                          />
                        </div>
                      </CWidgetProgressIcon>
                    </CCol>
                    <CCol md="3">
                      <CWidgetProgressIcon
                        :header="(statistic.devices.totalDisconnect && statistic.devices.totalDisconnect.toString()) || '0'"
                        text="Mất kết nối"
                        :inverse="true"
                        color="gradient-danger">
                        <i class="fa fa-unlink"></i>
                        <template slot="progress">
                          <CProgress
                            :value="getPercentDisConnect"
                            class="progress-xs progress-white my-3 mb-0"
                            :showPercentage="true"
                            :showValue="true"
                            color="secondary"
                            height="13px"
                            :striped="false"
                            :animated="true"
                          />
                        </template>
                      </CWidgetProgressIcon>
                    </CCol>
                    <CCol md="3">
                      <CWidgetProgressIcon
                        :header="(statistic.devices.totalActive && statistic.devices.totalActive.toString()) || '0'"
                        text="Đang hoạt động"
                        :inverse="true"
                        color="gradient-info">
                        <i class="fa fa-play"></i>
                        <template slot="progress">
                          <CProgress
                            :value="getPercentActive"
                            :showPercentage="true"
                            :showValue="true"
                            color="secondary"
                            height="13px"
                            :striped="false"
                            :animated="true"
                            class="progress-xs progress-white my-3 mb-0"
                          />
                        </template>
                      </CWidgetProgressIcon>
                    </CCol>
                    <CCol md="3">
                      <CWidgetProgressIcon
                        :header="(statistic.devices.totalInactive && statistic.devices.totalInactive.toString()) || '0'"
                        text="Không hoạt động"
                        :inverse="true"
                        color="gradient-warning">
                        <i class="fa fa-stop-circle"></i>
                        <template slot="progress">
                          <CProgress
                            :value="getPercentInactive"
                            :showPercentage="true"
                            :showValue="true"
                            color="secondary"
                            height="13px"
                            :striped="false"
                            :animated="true"
                            class="progress-xs progress-white my-3 mb-0"
                          />
                        </template>
                      </CWidgetProgressIcon>
                    </CCol>
                  </CCardBody>
                </CCard>
                <CCard v-if="statistic && statistic.files">
                  <CCardHeader color="light">
                    <i class="fa fa-file"></i>
                    <strong> Bản tin biên tập </strong>
                  </CCardHeader>
                  <CCardBody>
                    <CRow>
                      <CCol sm="2">
                        <h6 id="traffic" class="card-title mb-2">Từ ngày - đến ngày</h6>
                        <DatePicker id="datepicker" v-model="dateRange" locale="vi"
                                    :masks="{ input: 'DD/MM/YYYY', data : 'DD/MM/YYYY' }" :popover="{ visibility: 'click' }" is-range class="datepicker">
                          <template v-slot="{ inputValue, inputEvents }">
                            <input
                              :value="inputValue.start + ' - ' + inputValue.end"
                              v-on="inputEvents.start"
                              class="border px-2 py-1 rounded focus:outline-none focus:border-indigo-300"
                              readonly
                            />
                          </template>
                        </DatePicker>
                      </CCol>
                      <!--                                    <CCol sm="7" class="d-none d-md-block">-->
                      <!--                                      <CButtonGroup class="float-right mr-3">-->
                      <!--                                        <CButton-->
                      <!--                                          color="outline-secondary"-->
                      <!--                                          v-for="(value, key) in ['Day', 'Month', 'Year']"-->
                      <!--                                          :key="key"-->
                      <!--                                          class="mx-0"-->
                      <!--                                          :pressed="value === selected ? true : false"-->
                      <!--                                          @click="selected = value">-->
                      <!--                                          {{value}}-->
                      <!--                                        </CButton>-->
                      <!--                                      </CButtonGroup>-->
                      <!--                                    </CCol>-->
                    </CRow>
                    <MainChart style="height:350px;margin-top:40px;" :items="statistic.files"/>
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <BaseFormLoading :loading="loading.value"></BaseFormLoading>
  </div>
</template>

<script>
import BaseFormLoading from "@/views/base/BaseFormLoading";
import MainChart from "@/views/base/MainChart";
import {DatePicker} from "v-calendar";
import BaseSelect from "@/views/base/BaseSelect2";

export default {
  name: 'Dashboard',
  components: {BaseSelect, MainChart, BaseFormLoading, DatePicker},
  data() {
    let that = this;
    return {
      loading: {value: false},
      dateRange: {
        start: that.$helper.subtractNowDate(15),
        end: new Date()
      },
      districtCodeInput: {
        options: {
          filter: true,
          label: "Quận/Huyện",
          selectAllText: "Tất cả Quận/Huyện",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: (this.$hasAuthor('ROLE_ADMIN')) ? false : true
        },
        data: {
          name: "districtCode",
          items: [],
          model: '',
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {}
            },
            response: function (dataResponse) {
              that.districtCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      wardCodeInput: {
        options: {
          filter: true,
          label: "Phường/Xã",
          selectAllText: "Tất cả Phường/Xã",
          'keyField': 'key',
          'valueField': 'value',
          lazyLoad: true,
          disabled: false
        },
        data: {
          name: "wardCode",
          model: '',
          items: [],
          source: {
            url: '/common/findByParentCodeAndCode',
            dataSubmit: function () {
              return {
                parentCode: that.districtCodeInput.data.model
              }
            },
            response: function (dataResponse) {
              that.wardCodeInput.data.items = dataResponse.data;
            }
          },
        }
      },
      locationCode: {
        data: {
          name: 'locationCode',
          model: ''
        }
      },
      statistic: null,
      isFirstLoad: true
    }
  },
  created() {
  },
  mounted() {
    this.loadDataStatistic();
  },
  methods: {
    loadDataStatistic: function () {
      let that = this;
      this.$helper.loadDataSource({
        loading: that.loading,
        url: "/dashboard/statistic",
        dataSubmit() {
          return {
            fromDate: that.$helper.formatDate(that.dateRange.start),
            toDate: that.$helper.formatDate(that.dateRange.end),
            locationCode: that.locationCode.data.model
          }
        },
        isJsonContentType: false,
        ignoreDefaultData: false,
        successCallback: function (response) {
          if (that.$helper.validResponse(that.$router, response.data)) {
            that.statistic = response.data.data;
            that.isFirstLoad = false;
          }
        },
        errorCallback: function (error) {
          that.$helper.handleError(that.$router, error);
        }
      });
    },
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentConnect() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalConnect != null ? this.statistic.devices.totalConnect / this.statistic.devices.total * 100 : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentDisConnect() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalDisconnect != null ? this.statistic.devices.totalDisconnect / this.statistic.devices.total * 100 : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentActive() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalActive != null ? this.statistic.devices.totalActive / this.statistic.devices.total * 100 : 0;
      }
    },
    // eslint-disable-next-line vue/return-in-computed-property
    getPercentInactive() {
      if (this.statistic && this.statistic.devices) {
        return this.statistic.devices.totalInactive != null ? this.statistic.devices.totalInactive / this.statistic.devices.total * 100 : 0;
      }
    }
  },
  watch: {
    dateRange: function (newValue) {
      if (newValue) {
        this.loadDataStatistic();
      } else {
        this.dateRange = {
          start: new Date(),
          end: new Date()
        }
      }
    },
    'districtCodeInput.data.model': function (value) {
      if (value) {
        this.$refs.wardCodeInput.loadData();
        this.locationCode.data.model = value;
        this.wardCodeInput.options.disabled = false;
      } else {
        this.wardCodeInput.data.items = [];
        this.wardCodeInput.options.disabled = true;
      }
      this.wardCodeInput.data.model = ''
      this.locationCode.data.model = this.districtCodeInput.data.model;
      if (!this.isFirstLoad) {
        this.loadDataStatistic();
      }
    },
    'wardCodeInput.data.model': function (value) {
      if (value) {
        this.locationCode.data.model = value;
      } else {
        this.locationCode.data.model = this.districtCodeInput.data.model;
      }
      if (!this.isFirstLoad) {
        this.loadDataStatistic();
      }
    },
  }
}
</script>

<style scoped>

</style>
